import type { RegisteredComponent } from "@builder.io/sdk-react";

import { SpenderGridSection } from "~/hec/components/spender-page/spender-sections";

/** COM-478: the product grid as an authored block, filtered by the chip row and the balance. */
const SpenderGridBlock = ({
  attributes,
}: {
  attributes?: Record<string, unknown>;
}) => (
  <div data-testid="spender-grid-block-root" {...attributes}>
    <SpenderGridSection />
  </div>
);

export const SpenderGridDefinition = {
  component: SpenderGridBlock,
  name: "SpenderGrid",
  friendlyName: "FSA Spender product grid (FSA only)",
  noWrap: true,
  canHaveChildren: false,
} satisfies RegisteredComponent;

export default SpenderGridBlock;
